import { useEffect } from 'react';

const SEOHead = ({ title, description, canonical, ogImage }) => {
  useEffect(() => {
    document.title = title || 'Kalobrate | Making Workplace Culture Count';

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (description) {
      setMeta('name', 'description', description);
      setMeta('property', 'og:description', description);
      setMeta('name', 'twitter:description', description);
    }

    setMeta('property', 'og:title', title || 'Kalobrate | Making Workplace Culture Count');
    setMeta('name', 'twitter:title', title || 'Kalobrate | Making Workplace Culture Count');
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Kalobrate');

    if (canonical) {
      setMeta('property', 'og:url', `https://www.kalobrate.com${canonical}`);
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', `https://www.kalobrate.com${canonical}`);
    }

    if (ogImage) {
      setMeta('property', 'og:image', ogImage);
      setMeta('name', 'twitter:image', ogImage);
    }

    return () => {
      document.title = 'Kalobrate | Making Workplace Culture Count';
    };
  }, [title, description, canonical, ogImage]);

  return null;
};

export default SEOHead;
